import styled from "styled-components";

export const PlacementCardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  grid-column-gap: 16px;
  padding-bottom: 4px;
  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #B8C4CB;
    border-radius: 3px;
  }
  .item-wrapper{
    min-width: 220px;
    flex: 1;
    flex-shrink: 0;
    border: 2px solid #ECEFF1;
    background-color: #FFFFFF;
    border-radius: 8px;
    padding: 14px 16px;
    display: flex;
    flex-direction: column;
    grid-row-gap: 8px;
    cursor: pointer;
    .option-name-row {
      display: flex;
      align-items: center;
      grid-column-gap: 8px;
      .radio-dot {
        width: 16px;
        height: 16px;
        min-width: 16px;
        border-radius: 50%;
        border: 2px solid #9AA1AE;
        box-sizing: border-box;
      }
      .option-name {
        margin: 0;
        font-size: 12px;
        font-weight: 600;
        color: #4E5969;
      }
    }
    .fee-row {
      display: flex;
      align-items: baseline;
      grid-column-gap: 6px;
      .fee-amount {
        font-size: 24px;
        font-weight: 700;
        letter-spacing: -0.01em;
        color: #16181D;
      }
      .fee-label {
        font-size: 12px;
        color: #808183;
      }
    }
    &.active{
      background-color: #F3F6FE;
      border: 2px solid #1565D8;
      .option-name-row .radio-dot {
        border: 5px solid #1565D8;
      }
    }
    .items {
      display: flex;
      grid-column-gap: 16px;
    }
    .item-field {
      display: flex;
      grid-column-gap: 4px;
      align-items: baseline;
      p {
        margin: 0px;
        font-size: 12px;
        color: #4E5969;
        &:first-child {
          font-weight: 600;
          color: #16181D;
        }
      }
    }
  }
`;
